import uiBootstrap from 'angular-ui-bootstrap';
import translate from 'angular-translate';

export default angular.module('eventix.common.services.confirmDelete',[uiBootstrap, translate])
/**
 * @ngdoc service
 * @name eventix.common.services.ConfirmDelete
 * @requires ui.bootstrap
 * @description
 * A global service for asking user confirmation before deleting
 *
 * @example
 * <pre>
 * vm.delete = function(item) {
 *     ConfirmDelete.open(item.name).then( function(){
 *         return item.$delete();
 *     });
 * }
 * </pre>
 */
    .service('ConfirmDelete', function( $uibModal ){
        var template, Controller;

        /**
     * @ngdoc method
     * @name eventix.common.services.ConfirmDelete#open
     * @methodOf eventix.common.services.ConfirmDelete
     * @description
     * Open the confirmation dialog
     *
     * @param {String} identifier A name to identify the item which will be deleted
     * @param {Object} [translations] Optional object with translation overrides
     * Default value:
     * ```
     * {
     *      "title": "common.action.delete",
     *      "text": {
     *          "translation": "comomn.notice.deleteConfirm",
     *          "values": { "object": identifier.toString() }
     *      },
     *      "confirm": "common.action.delete",
     *      "cancel": "common.action.cancel"
     * }
     * ```
     * @returns {Promise} Resolves if the user confirms deletion, rejects otherwise
     */
        this.open = function(identifier, translations = {}) {
            var confirmation = $uibModal.open({
                template: template,
                controllerAs: 'vm',
                controller: ['translations',Controller],
                size: 'sm',
                resolve: {
                    translations: function() {
                        let t = _.defaultsDeep({}, translations, {
                            title: 'common.action.delete',
                            text: {
                                translation: 'common.notice.deleteConfirm',
                                values: {
                                    object: _.isString(identifier) ? identifier : _.toString(identifier)
                                }
                            },
                            confirm: 'common.action.delete',
                            cancel: 'common.action.cancel'
                        });
                        if(_.isString(t.text))
                            t.text = { translation: t.text };
                        return t;
                    }
                }
            });
            return confirmation.result;
        };

        Controller = function(translations) {
            this.translations = translations;
        };

        template = `<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ vm.translations.title | translate }}?</h4>
    </div>
    <div class="modal-body form-horizontal">
        <p translate="{{ vm.translations.text.translation }}" translate-values="vm.translations.text.values"></p>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default" ng-click="$dismiss()">{{ vm.translations.cancel | translate }}</button>
        <button class="btn btn-danger" ng-click="$close()">{{ vm.translations.confirm | translate }}</button>
    </div>
</div>`;
    }).name;
